module.exports = __webpack_public_path__ + "media/gong.c18bc571.wav";